<template>
  <ion-content class="ion-padding">
    <Teleport defer to="ion-app">
      <ion-modal
        id="example-modal"
        ref="ionModal"
        :swipe-to-close="true"
        :can-dismiss="true"
        @didDismiss="closeModal"
        @ion-breakpoint-did-change="closeModal"
      >
        <div
          class="wrapper rounded-[16px] p-[24px] md:p-[32px] lg:p-[36px] gap-[24px] md:gap-[28px] lg:gap-[32px]"
        >
          <div class="flex flex-col gap-8 px-[8px]">
            <div
              class="text-[1.5rem] md:text-[2.25rem] lg:text-[2.5rem] leading-[2.0625rem] md:leading-[2.75rem] lg:leading-[3rem] font-black text-[#2B2926] tracking-[-0.03em]"
            >
              {{ title }}
            </div>
            <div
              class="text-[1rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.5rem] md:leading-[2rem] lg:leading-[2.25rem] font-medium text-[#433D31]"
            >
              {{ line1 }}
            </div>
            <div
              class="text-[1rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.5rem] md:leading-[2rem] lg:leading-[2.25rem] font-medium text-[#433D31]"
            >
              {{ line2 }}
            </div>

            <div class="flex">
              <div class="w-[100%] h-[56px] md:h-[64px] lg:h-[72px]">
                <div
                  class="w-full bg-[#F6F4F0] text-[#42362B] text-[1.125rem] md:text-[1.25rem] lg:text-[1.375rem] font-semibold rounded-[100px] py-[16px] md:py-[18px] lg:py-[20px] text-center rounded-[24px] border border-[2px] border-[#42362B]"
                  @click="closeModal()"
                >
                  Got it!
                </div>
              </div>
            </div>
          </div>
        </div>
      </ion-modal>
    </Teleport>
  </ion-content>
</template>

<script>
import {
  IonButtons,
  IonButton,
  IonModal,
  IonHeader,
  IonToolbar,
  IonContent,
  IonTitle,
} from '@ionic/vue';

export default {
  components: {
    IonButtons,
    IonButton,
    IonModal,
    IonHeader,
    IonToolbar,
    IonContent,
    IonTitle,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    recurringGivingSelect: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      title: '',
      line1: '',
      line2: '',
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.$refs.ionModal?.$el?.present();
      } else {
        this.$refs.ionModal?.$el?.dismiss();
      }
    },
    recurringGivingSelect: {
      immediate: true,
      handler(newVal) {
        if (newVal === 'One-Time') {
          this.title = 'What is transaction limit?';
          this.line1 =
            'A transaction limit refers to the total amount that you can pay or transfer in a single transaction. It gives you greater control over how much money moves out of your bank account(s).';
          this.line2 = 'Once the a limit is exceeded, we will not be able to process the giving. ';
          ('Once the available amount has reached its limit, we will not be able to process the giving. Hence, we highly recommend not to set an account limit.');
        } else {
          this.title = 'What is transaction limit?';
          this.line1 =
            'A transaction limit refers to the total amount that you can pay or transfer in a single transaction. It gives you greater control over how much money moves out of your bank account(s).';
          this.line2 = 'Once the a limit is exceeded, we will not be able to process the giving. ';
          ('Once the available amount has reached its limit, we will not be able to process the giving. Hence, we highly recommend not to set an account limit.');
        }
      },
    },
  },
  mounted() {
    if (this.isOpen) {
      this.$nextTick(() => this.$refs.ionModal?.$el?.present());
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
ion-modal#example-modal {
  --width: 85%;
  --min-width: 250px;
  --height: fit-content;
  --border-radius: 12px;
  --box-shadow: 0 28px 48px rgba(0, 0, 0, 0.4);
}

ion-modal#example-modal h1 {
  margin: 20px 20px 10px 20px;
}

ion-modal#example-modal ion-icon {
  margin-right: 6px;

  width: 48px;
  height: 48px;

  padding: 4px 0;

  color: #aaaaaa;
}

ion-modal#example-modal .wrapper {
  padding: 24px;
  gap: 24px;
}
</style>
